import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import { mainContentColor, modalSubContentColor, modalContentColor } from "../lib/Color";
import Grid from '@material-ui/core/Grid';
import HeroSettingContent from './HeroSettingContent';
import ExtensionSettingContent from './ExtensionSettingContent';
import ArtSkillSettingContent from './ArtSkillSettingContent';
import SettingConfirmArea from "./settingConfirmArea/SettingConfirmArea";
import SettingModeLabel from "./SettingModeLabel";
import ModalCloseButton from "./ModalCloseButton";
import { AssetSettingModalProps } from "./hooks/AssetSettingModalType";

const AssetSettingModal = ({
    state,
    attackTeam,
    defenceTeam,
    heros,
    extensions,
    artSkillData,
    nextStateMode,
    backStateMode,
    setExtensionMode,
    updateTeamMemberHeroData,
    updateTeamMemberExtensionData,
    updateTeamMemberArtSkillData,
    onSelectStatePosition,
    onSelectStateModeAndPosition,
    onSelectStateFilterRarity,
    defenceTeamSelect,
    close,
    switchingStatePlayer,
    filterHeroData,
    filterExtensionData,
}: AssetSettingModalProps) => {
    const makeSettingContent = () => {
        switch (state.mode) {
            case "Hero":
                return <HeroSettingContent
                    isAuto={state.isAuto}
                    filterRarity={state.filterRarity}
                    selectedPosition={state.position}
                    heros={heros}
                    filterHeroData={filterHeroData}
                    updateTeamMemberHeroData={updateTeamMemberHeroData}
                    onSelectStatePosition={onSelectStatePosition}
                    nextStateMode={nextStateMode}
                    onSelectStateFilterRarity={onSelectStateFilterRarity}
                />;
            case 'ExtensionLeft':
            case 'ExtensionRight':
                return <ExtensionSettingContent
                    isAuto={state.isAuto}
                    state={state}
                    setExtensionMode={setExtensionMode}
                    selectedPosition={state.position}
                    extensions={extensions}
                    filterExtensionData={filterExtensionData}
                    updateTeamMemberExtensionData={updateTeamMemberExtensionData}
                    onSelectStatePosition={onSelectStatePosition}
                    onSelectStateFilterRarity={onSelectStateFilterRarity}
                    nextStateMode={nextStateMode}
                />;
            case 'ArtSkill':
                return <ArtSkillSettingContent
                    player={state.player}
                    isAuto={state.isAuto}
                    selectedPosition={state.position}
                    artSkillData={artSkillData}
                    updateTeamMemberArtSkillData={updateTeamMemberArtSkillData}
                    onSelectStatePosition={onSelectStatePosition}
                    defenceTeamSelect={defenceTeamSelect}
                    close={close}
                />;
            default:
                return <></>;
        }
    }
    const settingTeam = state.player === "Attack" ? attackTeam : defenceTeam

    return (
        <Dialog
            fullScreen
            open={state.isOpen}
            onClose={close}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent style={{ backgroundColor: mainContentColor }}>
                <Grid container spacing={3} style={{ flexGrow: 1 }}>
                    <Grid xs={4} style={{ backgroundColor: modalContentColor }} >
                        <SettingConfirmArea onSelectStateModeAndPosition={onSelectStateModeAndPosition} team={settingTeam} state={state} switchingStatePlayer={switchingStatePlayer} />
                    </Grid>
                    <ModalCloseButton close={close} />
                    <Grid xs={8} style={{ backgroundColor: modalContentColor }} >
                        {makeSettingContent()}
                        <Grid container style={{ backgroundColor: modalSubContentColor, height: "80px" }} alignItems="center" justify="center">
                            <Grid item xs={2}>
                                <Button variant="contained" color="secondary" size="large" onClick={backStateMode} style={{ margin: "10px" }}>
                                    戻る
                                </Button>
                            </Grid>
                            <Grid item xs={8}>
                                <SettingModeLabel mode={state.mode} />
                            </Grid>
                            <Grid item xs={2} style={{ textAlign: "right" }}>
                                {state.mode === "ArtSkill" ? <Button variant="contained" color="primary" size="large" onClick={
                                    close
                                } style={{ marginRight: "10px" }}>
                                    終了
                                </Button> : <Button variant="contained" color="primary" size="large" onClick={
                                    nextStateMode
                                } style={{ marginRight: "10px" }}>
                                    次へ
                                </Button>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog >
    );
}



export default AssetSettingModal;